import axios from "axios";
import config from "../config";

const host = `${config.REACT_APP_API_HOST}`;

console.log('host', host);

const APP_BASE_URL = host;

// Recupera o token e a licença do sessionStorage
const token = sessionStorage.getItem("token");
// const licenca = sessionStorage.getItem("license_value");

const api = axios.create({
  baseURL: APP_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(async (config: any) => {
  try {
    // Adiciona o token ao cabeçalho se estiver presente

    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;

  } catch (error: any) {
     console.log("AXIOS INTERCEPTORS: ", error);
  }
});

export { api, APP_BASE_URL };
